import React from 'react';
import SortIcon from '@assets/icons/sort.svg';
import { createStyles } from '@/contexts/theme-context';
import { ItemSortOrder } from '@/contexts/item-context-types';
import {
  SortOrderButton,
  Props as SortOrderButtonProps,
} from './sort-order-button';
import { SortOrders } from '@/contexts/user-context';
import { View } from 'react-native';

export const SECTION_HEADER_HEIGHT = 52;

export const SortOrderSectionHeader = <T extends SortOrders = ItemSortOrder>(
  props: SortOrderButtonProps<T>,
) => {
  const [styles, theme] = useStyles();
  return (
    <View style={styles.base}>
      <SortOrderButton<T>
        {...props}
        buttonProps={{
          leftElement: <SortIcon fill={theme.colors.primary} />,
          rightElement: null,
          rounded: true,
          size: 'xsmall',
          style: styles.button,
          type: 'secondary',
          ...(props.buttonProps ?? {}),
        }}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    alignItems: 'center',
    height: SECTION_HEADER_HEIGHT,
    justifyContent: 'center',
    paddingTop: 4,
  },
  button: {
    backgroundColor: theme.colors.background,
  },
}));
